var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78932 2.68359H3.10511C2.65843 2.68359 2.23004 2.86104 1.91419 3.17689C1.59834 3.49274 1.4209 3.92112 1.4209 4.3678V14.4731C1.4209 14.9197 1.59834 15.3481 1.91419 15.664C2.23004 15.9798 2.65843 16.1573 3.10511 16.1573H7.90258M13.2104 10.2625V13.631H16.5788M13.2104 7.73623V4.3678C13.2104 3.92112 13.0329 3.49274 12.7171 3.17689C12.4012 2.86104 11.9728 2.68359 11.5262 2.68359H9.84195",
    stroke: "#04245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78906 7.73684H8.15748M4.78906 11.1053H7.31538M4.78906 2.68421C4.78906 2.23753 4.96651 1.80914 5.28236 1.49329C5.59821 1.17744 6.02659 1 6.47327 1H8.15748C8.60416 1 9.03255 1.17744 9.3484 1.49329C9.66425 1.80914 9.84169 2.23753 9.84169 2.68421C9.84169 3.13089 9.66425 3.55928 9.3484 3.87513C9.03255 4.19098 8.60416 4.36842 8.15748 4.36842H6.47327C6.02659 4.36842 5.59821 4.19098 5.28236 3.87513C4.96651 3.55928 4.78906 3.13089 4.78906 2.68421ZM9.84169 13.6316C9.84169 14.5249 10.1966 15.3817 10.8283 16.0134C11.46 16.6451 12.3168 17 13.2101 17C14.1035 17 14.9602 16.6451 15.5919 16.0134C16.2236 15.3817 16.5785 14.5249 16.5785 13.6316C16.5785 12.7382 16.2236 11.8814 15.5919 11.2497C14.9602 10.618 14.1035 10.2632 13.2101 10.2632C12.3168 10.2632 11.46 10.618 10.8283 11.2497C10.1966 11.8814 9.84169 12.7382 9.84169 13.6316Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.bd175d8b69383b22d0607f3172d91170.svg";
export { ForwardRef as ReactComponent };